import { useEffect } from 'react';

const DURATIONS: Record<number, number> = {
  0: 4500,
  1: 4000,
  2: 4000,
  3: 3500,
  4: 0,
};

export function useSlideTimer(slide: number, onAdvance: () => void, paused: boolean) {
  useEffect(() => {
    const duration = DURATIONS[slide];
    if (!duration || paused) return;
    const id = setTimeout(onAdvance, duration);
    return () => clearTimeout(id);
  }, [slide, onAdvance, paused]);
}
